import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { log } from 'util';
import { forEach } from '@angular/router/src/utils/collection';
import { s } from '@angular/core/src/render3';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  showMobileCart: boolean = false;
  showMobileCartConfirm: boolean = false;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  options: any;
  getuintofmeasurement: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  Emp_Id: any;
  headerLabel: string;
  appSug: any = {};
  scheduler_id: any;
  emp_list: any;
  dataresult: any;
  date: Date;
  EMPS: any;
  getservicelists: any;

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;
  checkedItems: any[] = [];
  chekoutArray: any[] = [];
  tot_amt: any;
  discount: number = 0;
  getServiceProduct: any;
  isExpanded: boolean = true;
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  getCustomerCompl: any;
  serviceLoading: boolean = true;
  showUserForm: boolean = false;
  brands: any = [];
  selectedBrand: any = '';
  selectedProduct: any = '';
  selectedPercent: any;
  selected: any = [];
  products: any = [];
  selectedusedPercent: string;
  serIndexJ: any;
  seremployee_id_value: any;
  serIndexK: any;
  serunique_id_value: any;
  serservice_desc_id: any;
  serservice_desc: any;
  billingPreview: any = []
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) {

    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
    this.initVar();
    this.appSug = { lname: '' };

  }
  ngOnInit(): void {
    this.isExpanded = true;
    // this.loginservice.deletePastCheckouts().subscribe(data => { });
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('13');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
    this.loginservice.getServiceProduct(this.currentUser).subscribe(
      data => {
        if (data['data'].length > 0) {
          this.getServiceProduct = data['data'];
        } else {
          this.getServiceProduct = []
        }

      },
      error => {
        alert('Network Error getServiceProduct API');
        this.showLoader = false;
      });


    this.loginservice.getCustomerCompl(this.currentUser).subscribe(
      data => {
        if (data['data'].length > 0) {
          this.getCustomerCompl = data['data'];
        } else {
          this.getCustomerCompl = []
        }

      },
      error => {
        alert('Network Error getCustomerCompl API');
        this.showLoader = false;
      });


    if (this.loginservice.getLocalSession('customer_details') === null) {
      this.initVar();
      this.dataresult = [];
      this.getservicelists = [];
      // alert('isssss')
    } else {
      // alert('else')
      this.model = JSON.parse(this.loginservice.getLocalSession('customer_details'));
      this.model['customer_id'] = this.model['id'];
      this.model['employee_id'] = '';

      this.loginservice.checkCheckouts(this.model['customer_id'], this.currentUser).subscribe(
        data => {
          if (data['status'] == 'success') {
            this.delCustomerCheckout();
            this.delCheckout()
          }
        });
      this.getServiceList();
      this.previewBilling();
    }

    this.loginservice.getemp('', this.currentUser).subscribe(
      data => {
        if (data['comp_details'].length > 0) {
          this.EMPS = data['comp_details'];
        } else {
          this.EMPS = [];
          this.dataresult = [];
        }
      },
      error => {
        alert('Network Error getemp API');
        this.showLoader = false;
      });
    if (this.model['customer_id']) {
      // this.delCheckout();
    }


    this.loginservice.getBrands('notall', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.brands = data['data'];
          } else {
            this.brands = [];
          }
        }, error => { alert('Network Error getBrands API'); });

    this.loginservice.getAvailProducts('', this.currentUser)
      .subscribe(
        (data: any) => {
          if (data['service_product'].length > 0) {
            this.products = data['service_product'];
            // this.model.brand = 'All';
          } else {
            this.products = [];
          }
        }, error => { alert('Network Error getProducts API'); });

    this.selected = []
    this.showUserForm = false;
    this.selectedBrand = '';
    this.selectedProduct = '';
    this.selectedusedPercent = '';
    this.serIndexJ = '';
    this.serIndexK = '';
    this.seremployee_id_value = '';
    this.serunique_id_value = '';
    this.serservice_desc_id = '';
    this.serservice_desc = '';

  }


  getServiceList() {
    this.serviceLoading = true;
    this.loginservice.servicelist('', this.model['customer_id'], this.currentUser).subscribe(
      data => {
        // this.delCustomerCheckout();
        if (data['comp_details'].length > 0) {
          this.serviceLoading = false;
          if (this.model['mem_person'] == 2) {
            this.getservicelists = data['comp_details'].filter(offer => offer.type !== '7');
          } else {
            // Separate type 7 offers
            const typeSevenOffers = data['comp_details'].filter(offer => offer.type == '7' && offer.service_category_id == this.model.mem_id);
            // Retain all other offers (types 1 to 6)
            const otherOffers = data['comp_details'].filter(offer => offer.type !== '7');
            // Combine both filtered results (only relevant type 7 offers + all other offers)
            this.getservicelists = [...typeSevenOffers, ...otherOffers];
          }
          // this.model.employee_id = JSON.parse(this.loginservice.getLocalSession('billing_employee_id'));
          // if (this.model.employee_id) {
          //   this.setEmp();
          // }
        } else {
          this.serviceLoading = true;
          this.dataresult = [];
        }
      },
      error => {
        this.serviceLoading = true;
        alert('Network Error servicelist API');
        this.showLoader = false;
      });
  }
  delCheckout() {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      // Check if the key contains "chekoutArray"
      if (key.includes("chekoutArray")) {
        // Remove the item from local storage
        localStorage.removeItem(key);
      }
    }
    this.loginservice.delCheckout(this.model['customer_id'], this.currentUser).subscribe(
      data => {
        this.chekoutArray = [];
        this.tot_amt = 0;
        return true;
      },
      error => {
        alert('Network Error delCheckout API');
        this.showLoader = false;
      });
  }

  delCheckoutNew() {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      // Check if the key contains "chekoutArray"
      if (key.includes("chekoutArray")) {
        // Remove the item from local storage
        localStorage.removeItem(key);
      }
    }
    this.loginservice.delCheckoutNew(this.model['customer_id'], this.currentUser).subscribe(
      data => {
        this.chekoutArray = [];
        this.tot_amt = 0;
        return true;
      },
      error => {
        alert('Network Error delCheckoutNew API');
        this.showLoader = false;
      });
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term =>
        this.loginservice.getemployeeterm(term, 'customer_profile', this.currentUser)
          .do(() => this.searchFailed = false)
          .catch(() => {
            this.searchFailed = true;
            return Observable.of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed)
  formatter = (x: { f_name: string }) => '';

  asignModel(n) {
    if (typeof n === 'object') {
      this.model = n;
      this.model['employee_id'] = '';
      this.model['customer_id'] = n.id;
      this.delCheckout();
      this.delCustomerCheckout();
      this.model['scheduled_date'] = new Date(n['scheduled_date']);
      this.loginservice.setLocalSession(this.model, 'customer_details');
      this.Emp_Id = n.id;
      this.getServiceList();
      this.previewBilling();
      // if (typeof this.app.interview_date !== 'object') {
      //   this.app.interview_date = this._common.strToDates(n.interview_date);
      // }      
    } else {

    }
  }



  initVar() {
    this.appSug = { f_name: '' }
    this.model = {
      ...this.model,
      f_name: '',
      id: '',
      employee_id: '',
    };
  }

  initVar1() {
    this.delCheckout();
    this.delCheckoutNew();
    // this.delCustomerCheckout();
    this.initVar();
    this.model.employee_id = '';
  }
  chekspack1(covenants, i, type) {
    if (type === '1') {
      covenants['checked'] = false;
      this.chekspack(covenants, i, 'plus');
    } else {
      covenants.offered.forEach(element => {
        this.deleteoneitem(element, '');
      });
    }

    if (type === '1') {
      covenants['checked'] = true;
    } else {
      // covenants['checked'] = false
    }
  }

  chekspack(covenant, i, plus) {
    if (covenant.hasOwnProperty('checked') && covenant['checked'] === true) {
      covenant.offered.forEach((element, index) => {
        if (covenant.service_category_id === element.service_category_id) {
          let type: string;
          let ptag: string;
          let pValue: number;
          type = 'm';
          ptag = 'price_m';
          pValue = element.price_m;
          element.checked_s = true;
          element.checked_m = true;
          element.checked_l = true;
          let last = pValue + '-' + index + '-' + ptag + '-' + element.id + '-' + covenant.service_category_id;
          let amount = pValue;
          this.cheks(covenant, element, type, last, amount, '', '', '', index);
          type = 's';
          ptag = 'price_s';
          pValue = element.price_s;
          element.checked_s = true;
          element.checked_m = true;
          element.checked_l = true;
          let last_1 = pValue + '-' + index + '-' + ptag + '-' + element.id + '-' + covenant.service_category_id;
          let amount_1 = pValue;
          this.cheks(covenant, element, type, last_1, amount_1, '', '', '', index)
          type = 'l';
          ptag = 'price_l';
          pValue = element.price_l;
          element.checked_s = true;
          element.checked_m = true;
          element.checked_l = true;
          let last_2 = pValue + '-' + index + '-' + ptag + '-' + element.id + '-' + covenant.service_category_id;
          let amount_2 = pValue;
          this.cheks(covenant, element, type, last_2, amount_2, '', '', '', index)
          if (element.price_m > 0) {
            element.checked_s = false;
            element.checked_m = false;
            element.checked_l = false;
          } else if (element.price_s > 0) {
            element.checked_s = false;
            element.checked_m = false;
            element.checked_l = false;
          } else {
            element.checked_s = false;
            element.checked_m = false;
            element.checked_l = false;
          }
          element.checked_s = false;
          element.checked_m = false;
          element.checked_l = false;
          // 50-0-price_s-78-14
        }
      });
    } else {

      this.loginservice.checkProduct_bulk(covenant, this.model, 'm', this.currentUser).subscribe(
        data => {
          if (data['allow'] == 0) {
            let counter = 100
            covenant.offered.forEach((element, index) => {
              setTimeout(() => {
                if (covenant.service_category_id === element.service_category_id) {
                  let type: string;
                  let ptag: string;
                  let pValue: number;
                  if (element.price_m > 0) {
                    type = 'm';
                    ptag = 'price_m';
                    pValue = element.price_m;
                    element.checked_s = false;
                    element.checked_m = undefined;
                    element.checked_l = false;
                  } else if (element.price_s > 0) {
                    type = 's';
                    ptag = 'price_s';
                    pValue = element.price_s;
                    element.checked_s = undefined;
                    element.checked_m = false;
                    element.checked_l = false;
                  } else {
                    type = 'l';
                    ptag = 'price_l';
                    pValue = element.price_l;
                    element.checked_s = false;
                    element.checked_m = false;
                    element.checked_l = undefined;
                  }
                  let last = pValue + '-' + index + '-' + ptag + '-' + element.id + '-' + covenant.service_category_id;
                  let amount = pValue;

                  element.mainType = 'm'
                  const currentDate = new Date();
                  const year = currentDate.getFullYear();
                  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because January is 0
                  const day = String(currentDate.getDate()).padStart(2, '0');
                  element['mainlastId_date'] = `${last}-${type}-${year}-${month}-${day}`;
                  this.cheks(covenant, element, type, last, amount, '', '', '', index)
                  // 50-0-price_s-78-14
                  if (element.price_m > 0) {
                    this.getservicelists[i]['offered'][index].checked_m = true;
                  } else if (element.price_s > 0) {
                    this.getservicelists[i]['offered'][index].checked_s = true;
                  } else {
                    this.getservicelists[i]['offered'][index].checked_l = true;
                  }

                }
              }, counter)
              counter = counter + 500;
            });
          } else if (data['allow'] == 'success') {
            covenant.offered.forEach((element, index) => {

              if (covenant.service_category_id === element.service_category_id) {
                let type: string;
                let ptag: string;
                let pValue: number;
                if (element.price_m > 0) {
                  type = 'm';
                  ptag = 'price_m';
                  pValue = element.price_m;
                  element.checked_s = false;
                  element.checked_m = undefined;
                  element.checked_l = false;
                } else if (element.price_s > 0) {
                  type = 's';
                  ptag = 'price_s';
                  pValue = element.price_s;
                  element.checked_s = undefined;
                  element.checked_m = false;
                  element.checked_l = false;
                } else {
                  type = 'l';
                  ptag = 'price_l';
                  pValue = element.price_l;
                  element.checked_s = false;
                  element.checked_m = false;
                  element.checked_l = undefined;
                }
                let last = pValue + '-' + index + '-' + ptag + '-' + element.id + '-' + covenant.service_category_id;
                let amount = pValue;
                element.mainType = 'm'
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because January is 0
                const day = String(currentDate.getDate()).padStart(2, '0');
                element['mainlastId_date'] = `${last}-${type}-${year}-${month}-${day}`;
                element.checked_m = true;
                element.checked_m = true;
                element.checked_m = true;
              }
            });
            this.getcheckout();
          } else {
            this._flashMessagesService.show(data['data'].short_desc + " Is Out Of Stock For Service " + data['data'].service_desc, { cssClass: 'alert-danger' });
            alert(data['data'].short_desc + " Is Out Of Stock For Service " + data['data'].service_desc);
            // covenant.offered.forEach((element, index) => {
            //   if (covenant.service_category_id === element.service_category_id) {
            //     element.checked_s = false;
            //     element.checked_m = false;
            //     element.checked_l = false;
            //     element.lastId_date1 = element.lastId_date;
            //     this.removeFromCheckedArray(element, element.type);
            //   }
            // });
            if (plus == 'plus') {
            } else {
              covenant.checked = false;
            }
            if (confirm('Are You Want To Add More Quantity')) {
              window.open('/#/add-product/' + data['data']['inventory_manager_id_main_id'] + '/product/2/disable/disable', '_blank');
            }

          }
        },
        error => {
          alert('Network Error checkProduct_bulk API');
          this.showLoader = false;
        });
    }
  }

  addMinus(addMinus, covenant, item, type, last, amount, j) {

    const checked = 'checked_' + type;
    if (addMinus === '1') {
      item[checked] = false;
    } else {
      item[checked] = true;
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because January is 0
      const day = String(currentDate.getDate()).padStart(2, '0');

      // const currentDateFormatted = ``;

      item['date'] = `${year}-${month}-${day}`;
      // Append some unique identifier to the lastId
      item['lastId'] = `${last}-${type}-${j}`;
      item['lastId_date'] = `${last}-${type}-${year}-${month}-${day}-${j}`;
      this.deleteoneitem(item, type);
    }

    if (addMinus === '1') {
      this.cheks(covenant, item, type, last, amount, '', '', 'addMinus', j);
      item[checked] = true;
    } else {
      // item[checked] = false;
    }

  }

  deleteoneitem(item, type) {
    this.loginservice.deleteoneitem(item, this.model, this.currentUser, type).subscribe(
      data => {
        if (data['status'] === 'success') {
          this.getcheckout();
        }
      },
      error => {
        alert('Network Error deleteoneitem API');
        this.showLoader = false;
      });
  }
  cheks(covenant, item, type, last, amount, single, event, addMinus, j) {
    const checked = 'checked_' + type;
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because January is 0
    const day = String(currentDate.getDate()).padStart(2, '0');

    // const currentDateFormatted = ``;

    item['date'] = `${year}-${month}-${day}`;
    // Append some unique identifier to the lastId
    item['lastId'] = `${last}-${type}-${j}`;
    item['lastId_date'] = `${last}-${type}-${year}-${month}-${day}-${j}`;

    if (covenant['type'] == '2' && single == 'single') {
      item.checked_s = false;
      item.checked_m = false;
      item.checked_l = false;

      item.type = item.mainType;
      let _len = 0;
      if (item.mainlastId_date) {
        _len = item.mainlastId_date.split('-').length;
        if (_len === 9) {
          item.mainlastId_date = item.mainlastId_date + '-' + j
        }
      }
      item.lastId_date1 = item.mainlastId_date;

      this.removeFromCheckedArray(item, item.type);

      item.mainType = type;
      item.type = type
      item['mainlastId_date'] = item['lastId_date'];
      setTimeout(() => {
        // Check if the property exists in the item object and its value is true
        item[type] = true;
        item['amount'] = amount;
        // item[checked] = true;
        // setTimeout(() => { 
        this.addToCheckedArray(item, 0, checked, addMinus, item.type);
        //  }, 1000);
        // If the item is unchecked, remove it from the array
      }, 500);
      return true;
    }


    item.mainType = type;
    item.type = type
    item['mainlastId_date'] = item['lastId_date'];

    if (covenant['type'] == '7') {
      covenant['offered'].forEach((element, index) => {

        if (index != j) {
          covenant['offered'][index]['date'] = `${year}-${month}-${day}`;
          // Append some unique identifier to the lastId
          last = covenant['offered'][index].price_l + '-' + index + '-price_l-' + covenant['offered'][index].id + '-' + covenant.service_category_id
          covenant['offered'][index]['lastId'] = `${last}-${type}-${index}`;
          covenant['offered'][index]['lastId_date'] = `${last}-${type}-${year}-${month}-${day}-${index}`;
          // alert(`${last}`)
          // alert(last)
          // alert(covenant['offered'][index]['lastId_date'])
          covenant['offered'][index].mainType = type;
          covenant['offered'][index].type = type
          covenant['offered'][index]['mainlastId_date'] = covenant['offered'][index]['lastId_date'];
          covenant['offered'][index].lastId_date1 = covenant['offered'][index].lastId_date;
          this.removeFromCheckedArray(covenant['offered'][index], 'l');
          if (!element.disabled) {
            element.checked_l = false;
          }

        }
      });
    }

    // Check if the property exists in the item object and its value is true
    if (item.hasOwnProperty(checked) && item[checked] === true) {
      item.lastId_date1 = item.lastId_date;

      this.removeFromCheckedArray(item, item.type);
      // If the item is checked, add it to the array
    } else {
      item[type] = true;
      item['amount'] = amount;
      // item[checked] = true;
      // setTimeout(() => { 
      this.addToCheckedArray(item, 0, checked, addMinus, item.type);
      //  }, 1000);
      // If the item is unchecked, remove it from the array
    }
  }

  addToCheckedArray(item, quantity: number = 0, checked, addMinus, type) {
    // Add 'item' to your array here
    // For example:
    // this.checkedItems[item.lastId] = item;
    item['quantity'] = 1 + quantity;
    item['mode'] = 'add';
    this.loginservice.addEditcheckout(item, this.model, this.currentUser, type).subscribe(
      data => {
        if (data['status'] == 'success') {
          this.getcheckout();
        } else if (data['status'] == 'limitexist') {
          if (addMinus == 'addMinus') {
          } else {
            item[checked] = false
          }
          this._flashMessagesService.show(data['data'].short_desc + " Is Out Of Stock For Service " + data['data'].service_desc, { cssClass: 'alert-danger' });
          alert(data['data'].short_desc + " Is Out Of Stock For Service " + data['data'].service_desc);
          // if (data['id'] >= '1') {
          if (confirm('Are You Want To Add More Quantity')) {
            window.open('/#/add-product/' + data['data']['inventory_manager_id_main_id'] + '/product/2/disable/disable', '_blank');
          }
          // }
        } else {
          this.chekoutArray = []
        }
      },
      error => {
        alert('Network Error addEditcheckout API');
        this.showLoader = false;
      });
  }

  removeFromCheckedArray(item, type) {
    // Find the index of the item with the matching id
    // const index = this.checkedItems.findIndex(x => x.lastId === item.lastId);
    // // Check if the item with the matching id exists in the array
    // if (index !== -1) {
    //   // Remove the item from the array
    //   this.checkedItems.splice(index, 1);
    // }


    item['mode'] = 'edit';
    this.loginservice.addEditcheckout(item, this.model, this.currentUser, type).subscribe(
      data => {
        if (data['status'] == 'success') {
          // Assuming data is your array
          this.getcheckout();
        } else {
          this.chekoutArray = []
        }
      },
      error => {
        alert('Network Error getservicecategorysAddEdit API');
        this.showLoader = false;
      });
    // delete this.checkedItems[item.lastId];
  }

  getcheckout() {
    this.loginservice.getcheckout(this.model, this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success') {
          this.chekoutArray = [];
          this.discount = 0;
          this.chekoutArray = data['data'];
          this.tot_amt = 0;
          this.chekoutArray.forEach(element => {
            element.list.forEach(element => {
              this.tot_amt += parseInt(element['amount1']);
              this.getservicelists.forEach(ele => {
                ele.offered.forEach(eles => {
                  if (eles.id === element.service_desc_id && element.service_category_id === eles.service_category_id && element.off_id === eles.off_id) {
                    let result = element.unique_id.split('-')
                    let size = "checked_" + result[5];
                    eles[size] = true;
                  }
                });
              });
            });
            if ((element.start_date != '' && element.start_date != '0000-00-00') && (element.end_date != '' && element.end_date != '0000-00-00')) {
              if (element.curr_date >= element.start_date && element.curr_date <= element.end_date) {
                if (element.distype == 'amount') {
                  element.discount = this.discount += parseInt(element['disAmt']) * parseInt(element['list']['0']['quantity'])
                } else {
                  element.discount = this.discount += parseInt(element['totAmt']) / 100 * parseInt(element['disAmt']) * parseInt(element['list']['0']['quantity'])
                }
              } else {
              }
            } else {
              if (element.distype == 'amount') {
                element.discount = this.discount += parseInt(element['disAmt']) * parseInt(element['list']['0']['quantity'])
              } else {
                element.discount = this.discount += parseInt(element['totAmt']) / 100 * parseInt(element['disAmt']) * parseInt(element['list']['0']['quantity'])
              }
            }
          });
        } else {
          this.getservicelists.forEach(ele => {
            ele.offered.forEach(eles => {
              eles.checked_s = false;
              eles.checked_m = false;
              if (eles.checked_l == true) {

              } else {
                eles.checked_l = false
              }
              ;
            })
          });
          this.chekoutArray = [];
          if (this.chekoutArray.length <= 0) {
            this.discount = this.tot_amt = 0;
          }
        }
      },
      error => {
        alert('Network Error getcheckout API');
        this.showLoader = false;
      });
  }

  setEmp(employee_id) {

    if (this.model.employee_id) {
      this.loginservice.setLocalSession(this.model.employee_id, 'billing_employee_id');
      if (this.getservicelists.length > 0) {
        this.getservicelists.forEach(element => {
          element['offered'].forEach(elements => {
            elements.emp_id = this.model.employee_id;
          });
        });
        this.getcheckout();
      }
    } else {
      this.loginservice.setLocalSession(employee_id, 'billing_employee_id');
      if (this.getservicelists.length > 0) {
        this.getservicelists.forEach(element => {
          element['offered'].forEach(elements => {
            elements.emp_id = employee_id;
          });
        });
        this.getcheckout();
      }
    }


  }

  save() {
    if (this.chekoutArray.length <= 0) {
      this._flashMessagesService.show('Please Choose Service', { cssClass: 'alert-danger' });
      alert('Please Choose Service');
      return;
    }
    // On mobile — show cart confirm bottom sheet first
    if (window.innerWidth <= 768) {
      this.showMobileCart = true;
      this.showMobileCartConfirm = true;
      return;
    }
    this.proceedToCheckout();
  }

  proceedToCheckout() {
    let date = this.loginservice.getCurrentDateString();
    localStorage.removeItem('chekoutArray_' + this.model['customer_id'] + '_' + date);
    localStorage.removeItem('model');
    if (this.selected.length > 0) {
      this.loginservice.setLocalSession(this.selected, 'selectedProducts');
    }
    this.loginservice.setLocalSession(this.chekoutArray, 'chekoutArray_' + this.model['customer_id'] + '_' + date);
    this.loginservice.setLocalSession(this.model, 'model');
    this.showMobileCart = false;
    this.showMobileCartConfirm = false;
    this.router.navigate(['checkout']);
  }


  deleteEmp(id) {
    if (confirm('Deleting of this Employee is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridData(id, 'id', 'customer_profile', 'status').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Network Error deletegridData API');
            this.showLoader = false;
          });
      }
    }

  }

  movePreviousNext(modelVal, n) {
    this.showLoader = true;
    this.loginservice.movePreviousNextemp(modelVal, n, 'customer_profile', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.model = data['comp_details'][0];
            this.model['scheduled_date'] = new Date(data['comp_details'][0]['scheduled_date']);
            this.Emp_Id = this.model.id;
          } else {
            this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          }
          this.showLoader = false;
        },
        error => {
          alert('Network Error movePreviousNextemp API');
          this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          this.showLoader = false;
        });

  }


  sell() {
    let date = this.loginservice.getCurrentDateString();
    localStorage.removeItem('chekoutArray_' + this.model['customer_id'] + '_' + date);
    localStorage.removeItem('model');
    // if (this.chekoutArray.length > 0) {
    this.loginservice.setLocalSession(this.chekoutArray, 'chekoutArray_' + this.model['customer_id'] + '_' + date);
    this.loginservice.setLocalSession(this.model, 'model');
    this.router.navigate(['sell-product']);
    // } else {
    //   this._flashMessagesService.show('Please Choose Service', { cssClass: 'alert-danger' });
    //   alert('Please Choose Service');
    // }
  }

  cancelBilling() {
    this.showLoader = true;
    this.loginservice.delCustomerCheckout(this.model.id, this.currentUser)
      .subscribe(data => {
        this.showLoader = false;
        this.delCheckout();
        this.ngOnInit();
      },
        error => {
          alert('Network Error delCustomerCheckout API');
          this.showLoader = false;
        });


  }

  delCustomerCheckout() {
    if (this.model.id >= '1' || this.model.id >= 1) {
      this.showLoader = true;
      this.loginservice.delCustomerCheckout(this.model.id, this.currentUser)
        .subscribe(data => {
          this.showLoader = false;
        },
          error => {
            alert('Network Error delCustomerCheckout API');
            this.showLoader = false;
          });
    }
  }

  expandAll() {
    this.getservicelists.forEach(covenant => {
      if (covenant.offered && covenant.offered.length > 0) {
        covenant.isExpanded = !covenant.isExpanded;
        this.isExpanded = !covenant.isExpanded;
      }
      // If needed later:
      // covenant.offered.forEach(item => {
      //   if (item.checked_s === true || item.checked_m === true || item.checked_l === true) {
      //     covenant.isExpanded = true;
      //   }
      // });
    });
  }


  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

  toggleExpand(covenant: any) {
    if (covenant.offered && covenant.offered.length > 0) {
      covenant.isExpanded = !covenant.isExpanded;
      this.packCheck(covenant);
    }
  }

  removeCovenant(covenant: any) {
    const index = this.getservicelists.indexOf(covenant);
    if (index > -1) {
      this.getservicelists.splice(index, 1);
    }
  }


  packCheck(covenant: any) {
    // Only type 8 requires validation
    if (covenant.type !== '8') {
      return true;
    }
    // 1) No model or no packs → REMOVE ROW
    if (!this.model || !this.model.packs || this.model.packs.length === 0) {
      this.removeCovenant(covenant);
      return false;
    }
    // 2) Find matching pack by mem_id = service_category_id
    const pack = this.model.packs.find(
      p => p.mem_id == covenant.service_category_id
    );
    // If mem_id does NOT exist → REMOVE ROW
    if (!pack) {
      this.removeCovenant(covenant);
      return false;
    }

    // 3) Check payment (cash + gpay + card + online_banking + wallet + cheque)
    const paymentTotal =
      (Number(pack.cash) || 0) +
      (Number(pack.g_pay) || 0) +
      (Number(pack.card) || 0) +
      (Number(pack.online_banking) || 0) +
      (Number(pack.wallet) || 0) +
      (Number(pack.cheque) || 0);

    // If payment == 0 → REMOVE ROW
    if (paymentTotal <= 0) {
      this.removeCovenant(covenant);
      return false;
    }

    // 4) Validate start & end dates
    const start = pack.start_date;
    const end = pack.end_date;

    if (
      !start || start === "0000-00-00" ||
      !end || end === "0000-00-00"
    ) {
      this.removeCovenant(covenant);
      return false;
    }

    const today = new Date();
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Date NOT in range → REMOVE ROW
    if (!(today >= startDate && today <= endDate)) {
      this.removeCovenant(covenant);
      return false;
    }
    // Valid → allow row
    return true;
  }

  addUser(j, k, employee_id, unique_id, service_desc_id, service_desc) {
    this.showUserForm = true;
    this.serIndexJ = j;
    this.serIndexK = k;
    this.seremployee_id_value = employee_id;
    this.serunique_id_value = unique_id;
    this.serservice_desc_id = service_desc_id;
    this.serservice_desc = service_desc;

    // // Reload products fresh
    // this.showLoader = true;
    // this.loginservice.getAvailProducts('', this.currentUser).subscribe(
    //   (data: any) => {
    //     if (data['service_product'].length > 0) {
    //       this.products = data['service_product'];
    //     }
    //     this.showLoader = false;
    //   },
    //   error => {
    //     this.showLoader = false;
    //   }
    // );
  }

  cancelUserForm() {
    this.showUserForm = false;
    this.selectedBrand = '';
    this.selectedProduct = '';
    this.selectedusedPercent = '';
  }

  onBrandChange(selectedBrand) {
    // Reload products first to avoid mutation
    this.showLoader = true;
    this.loginservice.getAvailProducts('', this.currentUser).subscribe(
      (data: any) => {
        if (data['service_product'].length > 0) {
          this.products = selectedBrand
            ? data['service_product'].filter(x => x.brand == selectedBrand)
            : data['service_product'];
        }
        this.showLoader = false;
      },
      error => {
        this.showLoader = false;
      }
    );
  }

  saveUser(selectedBrand, selectedProduct, selectedusedPercent) {
    if (selectedProduct && selectedusedPercent) {
      let fil = this.products.filter(x => x.id == selectedProduct);
      if (!fil || fil.length === 0) return;

      // Create NEW object instead of mutating
      const productToAdd = {
        ...fil[0],
        used_percent: selectedusedPercent,
        serIndexJ: this.serIndexJ,
        serIndexK: this.serIndexK,
        seremployee_id_value: this.seremployee_id_value,
        serunique_id_value: this.serunique_id_value,
        serservice_desc_id: this.serservice_desc_id,
        serservice_desc: this.serservice_desc,
      };

      this.loginservice.checkExtraProd(productToAdd, this.currentUser)
        .subscribe(data => {
          if (data['status'] == 'success') {
            const availableBalance = parseFloat(data['data'][0]['balance_percent']);

            // Calculate already used quantity for this product
            const alreadyUsed = this.selected
              .filter(p => p.inventory_manager_id == productToAdd.inventory_manager_id)
              .reduce((sum, p) => sum + parseFloat(p.used_percent || 0), 0);

            const remainingBalance = availableBalance - alreadyUsed;
            const requestedAmount = parseFloat(productToAdd.used_percent);

            if (requestedAmount > remainingBalance) {
              alert(`Only ${remainingBalance} % available. Already used: ${alreadyUsed}`);
              this._flashMessagesService.show(
                `Only ${remainingBalance} % available. Already used: ${alreadyUsed}`,
                { cssClass: 'alert-danger' }
              );
              return;
            } else {
              this.selected.push(productToAdd);
              this.showUserForm = false;
              this.selectedBrand = '';
              this.selectedProduct = '';
              this.selectedusedPercent = '';
            }
          } else {
            this.showUserForm = false;
            this.selectedBrand = '';
            this.selectedProduct = '';
            this.selectedusedPercent = '';
            this._flashMessagesService.show('Product Not Available', { cssClass: 'alert-danger' });
          }
        });
    }
  }

  removeextraprod(extraprodId, ll) {
    this.selected.splice(ll, 1);
  }

  previewBilling() {
    this.serviceLoading = true;
    let data = {
      phone: this.model['phone'],
    };
    this.loginservice.getCustomerList(data, this.currentUser).subscribe(
      data => {
        // this.delCustomerCheckout();
        this.billingPreview = data['comp_details'];
        this.serviceLoading = false;
      })
  }

  getBillRowspan(billing: any[], index: number): number {
    if (index > 0 && billing[index - 1].bill_no === billing[index].bill_no) return 0;
    let count = 1;
    for (let i = index + 1; i < billing.length; i++) {
      if (billing[i].bill_no === billing[index].bill_no) count++;
      else break;
    }
    return count;
  }
}



// WEBPACK FOOTER //
// ./src/app/billing/billing.component.ts